import { memo } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { FACEBOOK_REELS, buildReelEmbedUrl } from "@/data/facebookReels";

const FacebookIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z" />
  </svg>
);

const ReelCard = ({ reel }) => (
  <div className="flex flex-col items-center" data-testid={`fb-reel-${reel.id}`}>
    <div className="rounded-xl overflow-hidden shadow-lg border border-slate-200 bg-white">
      <iframe
        src={buildReelEmbedUrl(reel.url, { width: 380, height: 476 })}
        width="380"
        height="591"
        loading="lazy"
        title={reel.caption || "Vidéo Mediastore"}
        style={{ border: "none", overflow: "hidden" }}
        scrolling="no"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      />
    </div>
    {reel.caption && (
      <p className="text-sm text-slate-600 mt-3 text-center max-w-xs">{reel.caption}</p>
    )}
  </div>
);

export const FacebookSection = memo(() => (
  <section
    className="section-padding bg-gradient-to-b from-slate-50 to-white"
    data-testid="home-facebook-section"
  >
    <div className="container-custom max-w-5xl">
      <div className="text-center mb-10">
        <Badge className="bg-[#1877F2] text-white px-4 py-2 mb-4 hover:bg-[#1877F2] inline-flex items-center gap-2">
          <FacebookIcon className="w-4 h-4" />
          Facebook @mediastore79
        </Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Mediastore sur Facebook
        </h2>
        <p className="text-lg text-slate-600">
          Suivez nos réparations en direct, nos promotions et nos conseils techniques sur Facebook.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-8">
        {FACEBOOK_REELS.map((reel) => (
          <ReelCard key={reel.id} reel={reel} />
        ))}
      </div>

      <div className="text-center mt-10">
        <a
          href="https://www.facebook.com/mediastore79"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="fb-cta-btn"
        >
          <Button size="lg" className="bg-[#1877F2] hover:bg-[#0d6cd6] text-white gap-2">
            <FacebookIcon className="w-5 h-5" />
            Suivez-nous sur Facebook
            <ArrowRight className="h-4 w-4" />
          </Button>
        </a>
      </div>
    </div>
  </section>
));

FacebookSection.displayName = "FacebookSection";
